import React, { useState } from "react";
import styles from "../styles/BetterSelect.module.scss";

export default function BetterSelect({
  name = "",
  value = "",
  onChange = () => {},
  onBlur = () => {},
  label = "",
  required = false,
  disabled = false,
  error = false,
  forceTouched = false,
  touched,
  errors,
  helperText = null,
  helperTextStyle = {},
  style = {},
  blankOption = false,
  forcePlaceholder = null,
  multiple = false,
  children,
}) {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (evento) => {
    setIsFocused(false);
    onBlur(evento);
  };

  const isBordaAtiva = isFocused || Boolean(value);
  const hasError = error || ((touched?.[name] || forceTouched) && errors?.[name]);

  return (
    <div className={styles.container} style={style}>
      <div className={styles.inputWrapper}>
        {label && (
          <label
            className={`${styles.floatingLabel} ${styles.floating} ${hasError ? styles.labelError : ""}`}
          >
            {label} {required && <span className={styles.requiredStar}>*</span>}
          </label>
        )}

        <select
          name={name}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={disabled}
          multiple={multiple}
          className={`${styles.select} ${isBordaAtiva ? styles.focused : ""} ${hasError ? styles.hasError : ""}`}
        >
          {forcePlaceholder && (
            <option disabled value="">{forcePlaceholder}</option>
          )}

          {blankOption && <option value="" />}

          {children}
        </select>

        <span className={styles.seta} aria-hidden="true">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M4 6L8 10L12 6" stroke="#555555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </div>

      {helperText && (
        <p className={styles.helperText} style={helperTextStyle}>{helperText}</p>
      )}

      {hasError && errors?.[name] && (
        <p className={styles.errorMessage}>{errors[name]}</p>
      )}
    </div>
  );
}
